import { UcoastEl } from '@/scripts/core/UcoastEl'
import { TsDOM as q } from '@/scripts/core/TsDOM'
import { type CartItems } from '@/scripts/cart/cart-items'
import { type CartDrawerItems } from '@/scripts/cart/cart-drawer-items'

export class CartSubscription extends UcoastEl {
  static htmlSelector = 'cart-subscription'

  oneTime: HTMLElement | null
  upgradeButton: HTMLElement | null
  subScription: HTMLElement | null
  selectedSubscription: HTMLHtmlElement |  null
  sellingPlanCheckBox: HTMLInputElement | null
  sellingPlans: NodeListOf<HTMLElement>

  constructor() {
    super()
	  this.oneTime = this.querySelector('.onetime-content')
    this.upgradeButton = this.querySelector('.onetime-content button')
    this.subScription = this.querySelector('.subscription-content')
	  this.selectedSubscription = this.querySelector('.subscription-label-selected')
	  this.sellingPlanCheckBox = this.querySelector('input')
    this.sellingPlans = this.querySelectorAll('[data-selling-plan-id]')

    /* selling plan click */
    this.sellingPlans.forEach((sellingPlan) => {
      sellingPlan.addEventListener('click', () => {
      if (sellingPlan.classList.contains('active')) {
        return
      }
      const planId = sellingPlan.dataset.sellingPlanId
      const planName = sellingPlan.textContent
      this.selectedSubscription!.querySelector('span')!.textContent = planName
        // reset active
        this.sellingPlans.forEach((el) =>
          el.classList.remove('active')
        )

      sellingPlan.classList.add('active')
		  this.sellingPlanCheckBox!.checked = false

        if (!planId) {
          // one-time
          this.oneTime?.classList.remove('hidden')
          this.subScription?.classList.remove('active')
        } else {
          // subscription selected
          this.oneTime?.classList.add('hidden')
          this.subScription?.classList.add('active')
        }

        this.updateSellingPlan(planId)
		
      })
    })

    /* one-time click */
    if (this.upgradeButton) {
      this.upgradeButton.addEventListener('click', (e) => {
        e.preventDefault()

        this.subScription?.classList.add('active')
        this.oneTime?.classList.add('hidden')

      })
    }
  }

  updateSellingPlan(planId: string | null) {
		const lineItemKey = this.dataset.lineItemKey
		const quantity = this.dataset.quantity || '1'
		
		if (!lineItemKey) {
			console.error('Missing line item key')
			return
		}

		const cartItems = q.oc<CartItems>(this, 'cart-items') || q.rc<CartDrawerItems>(this, 'cart-drawer-items')
		cartItems.updateQuantity(lineItemKey, quantity, undefined, planId)
	}
}